import { AutoMap } from "@automapper/classes"
import { ConsommableDTO } from "./consommable.dto"
import { SamplingPointDTO } from "./sampling-point.dto"
import { FlaconDTO } from "./flacon.dto"

export class PrelevementDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    ogiCode: string = ''
    @AutoMap()
    samplingJobId: number = 0
    @AutoMap()
    comment?: string;   
    @AutoMap()
    clientCode: string = ''
    @AutoMap()
    samplingPoint: SamplingPointDTO = new SamplingPointDTO()
    @AutoMap(() => [ConsommableDTO])
    consommable: ConsommableDTO[] = [];
    @AutoMap(() => [FlaconDTO])
    flaconList: FlaconDTO[] = [];
}